export default __webpack_public_path__ + "static/media/IMG_8804.173c3360.jpg";